module.exports = __webpack_public_path__ + "img/Booklist.d3783e35.png";